<template>
    <div>
        <page-header :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="loading" class="text-center py-4">
                            <i class="fas fa-spinner fa-spin fa-2x" />
                        </div>

                        <div
                            v-else-if="!sends.length"
                            class="text-center text-muted py-4"
                        >
                            No information has been sent yet.
                        </div>

                        <div v-else class="table-responsive">
                            <table
                                class="table table-centered table-striped"
                            >
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Doctor Name</th>
                                        <th>Specialty</th>
                                        <th>Role</th>
                                        <th>Medical ID</th>
                                        <th>Contact</th>
                                        <th>Category</th>
                                        <th>Files Sent</th>
                                        <th>User Status</th>
                                        <th>Doctor Approved</th>
                                        <th>Sent By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="send in sends"
                                        :key="send.id"
                                    >
                                        <td>{{ formatDate(send.created_at) }}</td>
                                        <td>
                                            {{
                                                [
                                                    send.first_name,
                                                    send.last_name
                                                ]
                                                    .filter(Boolean)
                                                    .join(' ') || '-'
                                            }}
                                        </td>
                                        <td>{{ send.specialty || '-' }}</td>
                                        <td>{{ send.role || '-' }}</td>
                                        <td>{{ send.medical_id || '-' }}</td>
                                        <td>
                                            <span
                                                class="badge"
                                                :class="
                                                    send.contact_type === 'SMS'
                                                        ? 'badge-primary'
                                                        : 'badge-secondary'
                                                "
                                            >
                                                {{ send.contact_type }}
                                            </span>
                                            <br />
                                            <small>
                                                {{
                                                    send.contact_type === 'SMS'
                                                        ? send.phone
                                                        : send.email
                                                }}
                                            </small>
                                        </td>
                                        <td>{{ send.category_name || '-' }}</td>
                                        <td>
                                            <ul
                                                v-if="
                                                    send.files_sent &&
                                                    send.files_sent.length
                                                "
                                                class="mb-0 pl-3"
                                            >
                                                <li
                                                    v-for="(
                                                        file, idx
                                                    ) in send.files_sent"
                                                    :key="idx"
                                                >
                                                    <small>
                                                        <span
                                                            class="badge badge-sm"
                                                            :class="
                                                                file.type ===
                                                                'PDF'
                                                                    ? 'badge-danger'
                                                                    : 'badge-info'
                                                            "
                                                        >
                                                            {{ file.type }}
                                                        </span>
                                                        {{ file.name }}
                                                    </small>
                                                </li>
                                            </ul>
                                            <span v-else>-</span>
                                        </td>
                                        <td>
                                            <span
                                                class="badge"
                                                :class="
                                                    send.is_existing_user
                                                        ? 'badge-success'
                                                        : 'badge-warning'
                                                "
                                            >
                                                {{
                                                    send.is_existing_user
                                                        ? 'Existing User'
                                                        : 'New User'
                                                }}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                class="badge"
                                                :class="
                                                    send.doctor_approved
                                                        ? 'badge-success'
                                                        : 'badge-secondary'
                                                "
                                            >
                                                {{
                                                    send.doctor_approved
                                                        ? 'Yes'
                                                        : 'No'
                                                }}
                                            </span>
                                        </td>
                                        <td>{{ send.sent_by || '-' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '@config';

export default {
    page: {
        title: 'Sent Info History',
        meta: [{ name: 'description', content: config.description }]
    },

    data() {
        return {
            title: 'Sent Info History',
            items: [
                { text: 'NovoCare', to: '/' },
                { text: 'Sent Info History', active: true }
            ],
            sends: [],
            loading: true
        };
    },

    async mounted() {
        try {
            this.sends = await this.getSends();
        } catch (err) {
            console.error(err);

            this.$bvToast.toast('Failed to load history.', {
                title: 'Error!',
                variant: 'danger',
                solid: true
            });
        } finally {
            this.loading = false;
        }
    },

    methods: {
        ...mapActions({
            getSends: 'doctorInfoSends/index'
        }),

        formatDate(dateString) {
            if (!dateString) {
                return '-';
            }

            const date = new Date(dateString);

            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    }
};
</script>
